<template>
  <div id="pwaPanel">
    <popup ref="popup" type="center" @close="popClose">
      <div class="pwa_panel">
        <!-- <img class="logo_img" src="./images/addDeskImg/MJ-logo.png"> -->
        <div class="panel_title">建议您把 <span class="obj_title">MJ绘画中文站</span> 添加到您的电脑桌面
        </div>
        <div class="panel_content">
          <div class="content_top" style="color:#ec3b3b;">仅需一秒，无须下载，即可添加</div>
          <div class="content_body">
            <div class="pwa_icon">
              <img class="icon_img" src="../views/objIcon/MJ.png" alt="">
              <img class="kjfs_icon" src="./images/addDeskImg/img_icon_85.png" alt="">
            </div>
            <div class="content_text">下次访问{{ site_name }}，无需搜索，一键直达</div>
            <div @click="installNow">
              <div class="step_btn">
                第一步：点此开始
                <img class="click_icon" src="./images/addDeskImg/img_icon_14.png" alt="">
              </div>
            </div>
            <div class="content_text" style="color:#424242;">第二步：点击浏览器顶部的
              <div @click="installNow">
                <span class="install_btn">安装</span></div> 即可
            </div>
            <div class="content_text">目前有 6588321 位用户把{{ site_name }}放到电脑桌面</div>
          </div>
        </div>
        <div class="panel_bottom">
          <div @click="popClose(1)" class="skip">已添加，点此跳过<i class="el-icon-d-arrow-right"></i></div>
        </div>
        <div class="close_btn" @click="popClose(0)"><img class="close_img" src="./images/addDeskImg/img_icon_24.png"/></div>
      </div>
    </popup>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"

export default {
  components: {popup},
  data() {
    return {
      site_name: SITE_NAME,
      site_logo: 'logo_obj.png',
      desk_app_url: DESK_APP_URL,

    }
  },
  created() {

  },
  methods: {
    show() {
      this.$refs.popup.show();
    },
    popClose(data) {
      if(data){
        localStorage.setItem('eveClose',1)
      }
      this.hidePwaToday()
      this.$refs.popup.close();
    },
    installNow() {
      let that = this
      deferredPrompt.prompt()
      this.popClose();
      let user_id = localStorage.getItem("user_id") || 0;
      deferredPrompt.userChoice.then(function (e) {
        if (e.outcome === 'dismissed') {
          // 不允许
          //埋点
          that.$http.post('/wap/jsstat/browser/record/', {
            user_id: user_id,
            mod_code: "pwacancel2",
            site_url: MAIN_URLROOT
          })
          this.hidePwaToday()

        } else {
          // 允许
          //埋点
          that.$http.post('/wap/jsstat/browser/record/', {
            user_id: user_id,
            mod_code: "pwaadd2",
            site_url: MAIN_URLROOT
          })
        }
      })
    },
    hidePwaToday() {
      let today = new Date();
      // 将时间部分清零（只保留年月日）
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);

      // 创建明天的日期对象
      let tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1); // 加上一天

      localStorage.setItem("HIDEPWATIMEpwa", tomorrow.getTime());
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#pwaPanel{

}

.pwa_panel {
  width: 452px;
  position: relative;
  padding: 12px 46px 32px;
  text-align: center;
  background-color: #fff;
  border-radius: 5px;
  transform-origin: center;
  /* 设置缩放中心点为元素中心 */
  animation: scaleIn 1s ease-out forwards;
  font-size: 14px;

  .panel_title {
    font-size: 28px;
    line-height: 54px;
    padding-bottom: 5px;
    color: #424242;
    .obj_title{
        color: transparent;
        background-image: linear-gradient(to right, #ff7b95, #ec3b3b);
        -webkit-background-clip: text;
        background-clip: text;
    }

    .logo_img {
      width: 150px;
      margin: -3px 12px 0;
      vertical-align: middle;
    }
  }

  .panel_content {
    .content_top {
      height: 50px;
      margin-bottom: 16px;
      border: 1px solid #ddd;
      background-color: #f5f5f5;
      line-height: 50px;
      position: relative;
      color: #999;
      border-radius: 3px;

      &::after {
        content: "";
        position: absolute;
        display: block;
        width: 14px;
        height: 14px;
        border: 1px solid #ddd;
        border-top-color: transparent;
        border-left-color: transparent;
        left: 50%;
        bottom: -7px;
        box-sizing: border-box;
        transform-origin: center;
        transform: rotate(45deg);
        background-color: #f5f5f5;
      }
    }

    .content_body {
      height: 340px;
      border-radius: 3px;
      border: 1px solid #ccc;
      position: relative;
      background-color: #f5f5f5;
      padding-top: 30px;

      .pwa_icon {
        position: relative;
        margin-bottom: 2px;
        width: 54px;
        margin: 0 auto;

        .icon_img {
          width: 54px;
          height: 54px;
          display: block;
          border-radius: 8px;
          border: 2px solid #cdcdcd;
        }

        .kjfs_icon {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 16px;
          border: none;
        }
      }

      .content_text {
        padding-top: 16px;
        line-height: 34px;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: center;

        .install_btn {
          display: inline-block;
          vertical-align: middle;
          height: 26px;
          line-height: 26px;
          width: 46px;
          margin: -2px 18px 0;
          border-radius: 3px;
          border: 1px solid #ec3b3b;
          color: #ec3b3b;
          background: #fac9c9;
          cursor: pointer;
        }
      }

      .step_btn {
        width: 280px;
        margin: 20px auto 24px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        background-color: #ec3b3b;
        border-radius: 3px;
        margin-bottom: 7px;
        cursor: pointer;

        .click_icon {
          width: 15px;
          vertical-align: text-top;
          margin: 2px 0 0 7px;

        }
      }
    }
  }

  .panel_bottom {
    padding-top: 32px;
    line-height: 34px;
    color: #ccc;

    .skip {
      cursor: pointer;
    }
  }

  .close_btn {
    position: absolute;
    bottom: -92px;
    left: 50%;
    width: 45px;
    height: 45px;
    margin-left: -22px;
    cursor: pointer;
    padding-top: 13px;
    background-color: #ec3b3b;
    border-radius: 50%;

    .close_img {
      display: block;
      width: 18px;
      margin: 0 auto;
      border: none;
    }
  }
}
  @keyframes scaleIn {
    0% {
      transform: scale(0);
      /* 开始时完全缩小 */
      opacity: 0;
      /* 可选：开始时完全透明 */
    }

    100% {
      transform: scale(1);
      /* 结束时正常大小 */
      opacity: 1;
      /* 可选：结束时完全不透明 */
    }
  }
</style>